<proffeo-ui-dialog
  [title]="`${('project-locations.modals.edit-modal-title' | translate)}: ${$safeNavigationMigration(location?.name)}`"
>
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex flex-col w-full gap-2">
      <div class="flex w-full gap-2 flex-col">
        <proffeo-ui-input
          [formField]="form.name"
          label="project-locations.modals.form-label-name"
          prefixIcon="text_fields"
        />

        <proffeo-file-drop (filesAdded)="onFileAdded($event)"></proffeo-file-drop>
        <proffeo-thumbnails-carousel
          (fileDelete)="onFileDelete($event)"
          (thumbnailClick)="onThumbnailClick($event)"
          [files]="locationFiles()"
          [allowDelete]="true"
        ></proffeo-thumbnails-carousel>
      </div>
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
